import React, { useCallback, useState } from "react";
import "./Banner.scss";
import doctor from "../../../src/Assets/doctor.png";
import cirarrow from "../../../src/Assets/cirarrow.png";
import threef from "../../../src/Assets/threefigur.png";
import logod from "../../../src/Assets/logodb.png";
import logotop from "../../../src/Assets/logodtwo.png";
import logobtm from "../../../src/Assets/logodone.png";
import btmcir from "../../../src/Assets/circlecc.png";
import { useNavigate } from "react-router-dom";
import API from "../../Api/Api";
import ENDPOINTS from "../../Api/Endpoints";
import { tokenManager } from "../../Api/tokenManager";
import { BANNER_BODY, getBannerTrustBlock } from "../../content/landingContent";

export default function Banner() {
  const navigate = useNavigate();
  const [bookLoading, setBookLoading] = useState(false);

  const handleBookClick = useCallback(async () => {
    if (bookLoading) return;

    const token = tokenManager.getTokenForRole("patient");
    if (!token) {
      navigate("/Signup");
      return;
    }

    try {
      setBookLoading(true);

      // const [meRes, presRes, activeRes] = await Promise.allSettled([
      //     API.get(ENDPOINTS.GET_ME, {
      //         params: { _t: Date.now() },
      //         headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      //     }),
      //     API.get(ENDPOINTS.GET_MY_PRESCRIPTIONS, {
      //         params: { _t: Date.now() },
      //         headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      //     }),
      //     API.get(ENDPOINTS.GET_ACTIVE_MATCH_REQUEST, {
      //         params: { _t: Date.now() },
      //         headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
      //     }),
      // ]);

      const [meRes, activeRes] = await Promise.allSettled([
        API.get(ENDPOINTS.GET_ME, {
          params: { _t: Date.now() },
          headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
        }),
        API.get(ENDPOINTS.GET_ACTIVE_MATCH_REQUEST, {
          params: { _t: Date.now() },
          headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
        }),
      ]);

      const mePayload =
        meRes.status === "fulfilled"
          ? (meRes.value?.data ?? meRes.value ?? {})
          : {};
      const user = mePayload?.user || mePayload?.data?.user || {};

      //   const presPayload =
      //     presRes.status === "fulfilled"
      //       ? (presRes.value?.data ?? presRes.value ?? {})
      //       : {};
      //   const verificationStatus = String(
      //     presPayload?.verificationStatus ||
      //       presPayload?.data?.verificationStatus ||
      //       "",
      //   ).toLowerCase();
      //   if (verificationStatus !== "accepted") {
      //     navigate("/upload-complete");
      //     return;
      //   }

      const selectedSelections = Array.isArray(user?.selectedSelections)
        ? user.selectedSelections
        : [];
      const selectedSubCategoryIds = Array.isArray(user?.selectedSubCategoryIds)
        ? user.selectedSubCategoryIds
        : [];
      const hasSelection =
        selectedSelections.length > 0 || selectedSubCategoryIds.length > 0;

      const accountStatus = String(
        user?.adminApprovalStatus || "",
      ).toLowerCase();
      if (accountStatus !== "approved") {
        navigate(hasSelection ? "/pending-approval" : "/HealBidDashboard");
        return;
      }

      const activePayload =
        activeRes.status === "fulfilled"
          ? (activeRes.value?.data ?? activeRes.value ?? {})
          : {};
      const hasOngoingMatch = Boolean(activePayload?.ongoing);
      if (hasOngoingMatch) {
        navigate("/care-price");
        return;
      }

      navigate(hasSelection ? "/care-price" : "/request/new");
    } catch (_) {
      navigate("/request/new");
    } finally {
      setBookLoading(false);
    }
  }, [bookLoading, navigate]);

  const trust = getBannerTrustBlock();

  return (
    <div>
      <div className="back_color dotss">
        <div className="container dotback">
          <div className="healthcare_flex">
            <span className="logo_banner" aria-hidden="true">
              <img src={logod} alt="" />
            </span>
            <span className="logoo_banner" aria-hidden="true">
              <img src={logotop} alt="" />
            </span>
            <span className="lo_go_banner" aria-hidden="true">
              <img src={logobtm} alt="" />
            </span>
            <span className="btm_banner" aria-hidden="true">
              <img src={btmcir} alt="" />
            </span>
            <div className="helth that">
              <h1 className="heal_h">
                Know your{" "}
                <span className="colorblack">operation cost for free</span>{" "}
                before you choose a hospital
              </h1>
              <p className="contac_t">{BANNER_BODY}</p>
              <div className="bok_flex">
                <button
                  className="btn_book"
                  type="button"
                  onClick={handleBookClick}
                  disabled={bookLoading}
                >
                  <span>{bookLoading ? "Loading..." : "Get Started"}</span>
                  <span className="btn_icon" aria-hidden="true">
                    <img className="baro" src={cirarrow} alt="" />
                  </span>
                </button>
              </div>

              <div className="appo_flex">
                <span>
                  <img
                    src={threef}
                    alt="Illustration representing patients comparing care options"
                  />
                </span>
                <div className="appoint">
                  <p className="app-int">{trust.headline}</p>
                  <p className="pat">{trust.subline}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="dct">
            <figure className="doctor_banner ">
              <img
                src={doctor}
                alt="Doctor with a friendly expression, representing trusted care on HealBid"
              />
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
}
